import { Button } from "@bindery/ui/components/ui/button";
import type { ComponentProps, ReactNode } from "react";
import { reloadWhenRestored } from "./enter";
import type { ReaderEntry } from "./links";

type ButtonLook = Pick<ComponentProps<typeof Button>, "variant" | "className">;

// A real form, so the device's reader rides the body even with scripts off.
export function ReaderEntryButton({
  entry,
  children,
  ...look
}: { entry: ReaderEntry; children: ReactNode } & ButtonLook) {
  if (entry.method === "get") {
    return (
      <Button asChild {...look}>
        <a href={entry.href}>{children}</a>
      </Button>
    );
  }
  return (
    <form
      method="post"
      action={entry.action}
      onSubmit={() => reloadWhenRestored()}
    >
      {Object.entries(entry.fields).map(([name, value]) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
      <Button type="submit" {...look}>
        {children}
      </Button>
    </form>
  );
}
